import { BlockModule } from '@/website/blocks/common'

new BlockModule({
    selector: '.block-tabs',
    setupBlock(el, onTeardown) {
        const defaultValue = el.getAttribute('data-default-value')
        const tabButtons = el.querySelectorAll('.tab-button')
        const tabPanels = el.querySelectorAll('.tab-panel')

        el
            .querySelector(`.tab-panel[data-value="${defaultValue}"]`)
            ?.setAttribute('data-state', 'active')

        tabButtons.forEach((button) => {
            const tabId = button.getAttribute('data-value')

            const evtListener = () => {
                tabButtons.forEach((btn) => {
                    btn.setAttribute('data-state', 'inactive')
                })

                button.setAttribute('data-state', 'active')

                tabPanels.forEach((el) => el.setAttribute('data-state', 'inactive'))
                el
                    .querySelector(`.tab-panel[data-value="${tabId}"]`)
                    ?.setAttribute('data-state', 'active')

                if (tabId) el.setAttribute('data-value', tabId)
            }

            button.addEventListener('click', evtListener)

            onTeardown(() => {
                button.removeEventListener('click', evtListener)
            })
        })
    },
})
